<template>
  <div class="duty-class-attend">
    <van-nav-bar left-arrow @click-left="goBack" fixed placeholder>
      <template #title>
        <div class="nav-title">{{ pageTitle }}</div>
      </template>
    </van-nav-bar>

    <!-- 只读提示 -->
    <div class="readonly-bar">
      <van-icon name="eye-o" color="#52c1b2" />
      <span>巡课查看（只读，不可修改考勤）</span>
    </div>

    <!-- 统计信息（仅展示，不可操作） -->
    <div class="stats-bar">
      <div class="stat-item">
        <span class="stat-num">{{ students.length }}</span>
        <span class="stat-label">总人数</span>
      </div>
      <div class="stat-item present">
        <span class="stat-num">{{ presentCount }}</span>
        <span class="stat-label">已到</span>
      </div>
      <div class="stat-item absent">
        <span class="stat-num">{{ absentCount }}</span>
        <span class="stat-label">未到</span>
      </div>
    </div>

    <!-- 学生列表（只读，参照 StudentAttend 展示，无任何操作） -->
    <div class="student-list" v-if="students.length > 0">
      <div
        class="student-item"
        v-for="student in students"
        :key="student.student_id"
        :class="{ 'status-absent': student.status === 0 }"
      >
        <div class="student-info">
          <div class="student-name">
            {{ student.name }}
            <span v-if="student.is_leave == 1" class="leave-tag">请假</span>
          </div>
          <div class="student-class">{{ student.class_name }}</div>
        </div>
        <div class="status-tag">
          <span v-if="student.status === 1" class="tag-present">已到</span>
          <span v-else class="tag-absent">未到</span>
        </div>
      </div>
    </div>

    <van-empty v-else description="暂无学生数据" />
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast, Icon, NavBar, Empty } from "vant";
import api from "../service/api";

export default {
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Empty.name]: Empty,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    // 巡课列表单点传入：serviceClassId=班级 class_id（即 service_class_id 业务主键）
    // 接口 dutyGetServiceClassInfo 参数 { sid, service_class_id, search_date }
    const serviceClassId = route.query.serviceClassId;
    const date = route.query.date;
    const title = route.query.title || "";
    const students = ref([]);

    const pageTitle = computed(() => {
      return `${date || ""}  ${title || ""}`;
    });

    const presentCount = computed(
      () => students.value.filter((s) => s.status === 1).length
    );
    const absentCount = computed(
      () => students.value.filter((s) => s.status === 0).length
    );

    const load = async () => {
      try {
        Toast.loading({ message: "加载中...", forbidClick: true });
        const res = await api.dutyGetServiceClassInfo({
          sid: localStorage.getItem("sid"),
          service_class_id: serviceClassId,
          search_date: date,
        });
        Toast.clear();
        if (res.data.code == 1001) {
          const result = res.data.result;
          // attendance_status == 0 时默认所有人未签到（与 StudentAttend 口径一致）
          students.value = (result.student_list || []).map((student) => ({
            ...student,
            status: result.attendance_status == 0 ? 0 : student.status,
          }));
        } else {
          Toast(res.data.message);
        }
      } catch (error) {
        Toast.clear();
        Toast("获取考勤状态失败");
      }
    };

    const goBack = () => router.back();

    onMounted(() => {
      load();
    });

    return {
      pageTitle,
      students,
      presentCount,
      absentCount,
      goBack,
    };
  },
};
</script>

<style lang="less" scoped>
.duty-class-attend {
  min-height: 100vh;
  background: #f2f2f2;
  padding-bottom: 20px;
}

.nav-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
  word-break: break-all;
  white-space: normal;
  line-height: 1.4;
  text-align: center;
  padding: 0 8px;
}

.readonly-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 15px;
  font-size: 12px;
  color: #52c1b2;
  background: #eefaf7;
}

.stats-bar {
  display: flex;
  background: #fff;
  padding: 15px;
  margin-bottom: 1px;
}
.stat-item {
  flex: 1;
  text-align: center;
  .stat-num {
    display: block;
    font-size: 22px;
    font-weight: 700;
    color: #333;
  }
  .stat-label {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
  &.present .stat-num {
    color: #07c160;
  }
  &.absent .stat-num {
    color: #ee0a24;
  }
}

.student-list {
  padding: 10px;
}
.student-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  margin-bottom: 8px;
  background: #fff;
  border-radius: 10px;

  &.status-absent {
    background: #fff5f5;
  }
}
.student-info {
  flex: 1;
  min-width: 0;
}
.student-name {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}
.student-class {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
  word-break: break-all;
  white-space: normal;
}
.leave-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 500;
  color: #ff976a;
  background: #fff0e8;
  vertical-align: middle;
}
.status-tag {
  flex-shrink: 0;
  margin-left: 10px;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}
.tag-present {
  color: #07c160;
  background: #e8f8ef;
}
.tag-absent {
  color: #ee0a24;
  background: #fff0f0;
}
</style>
